// src/frontend/pages/admin/PerformancePatients.jsx
import { useState } from "react";
import { PerformanceAdminView, PatientsAdminView } from "@pages";
import { useOverviewPerformance, useOverviewPatients } from "@api/hooks";

export default function PerformancePatients({ date }) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [patientsPage, setPatientsPage] = useState(1);
  const [patientsPageSize, setPatientsPageSize] = useState(10);

  // Fetch performance data for all clinics on the specified date
  const {
    data: performanceData,
    isLoading,
    error,
  } = useOverviewPerformance(
    {
      date,
    },
    { enablePolling: true },
  );

  // Fetch patients data for all clinics on the specified date
  const {
    data: patientsData,
    isLoading: patientsLoading,
    error: patientsError,
  } = useOverviewPatients(
    {
      date,
    },
    { enablePolling: true },
  );

  return (
    <>
      <PerformanceAdminView
        date={date}
        data={performanceData}
        isLoading={isLoading}
        error={error}
        page={page}
        pageSize={pageSize}
        onPageChange={setPage}
        onPageSizeChange={(n) => {
          setPage(1);
          setPageSize(n);
        }}
      />
      <PatientsAdminView
        date={date}
        data={patientsData}
        isLoading={patientsLoading}
        error={patientsError}
        page={patientsPage}
        pageSize={patientsPageSize}
        onPageChange={setPatientsPage}
        onPageSizeChange={(n) => {
          setPatientsPage(1);
          setPatientsPageSize(n);
        }}
      />
    </>
  );
}
